import React from "react";
import { Route, Switch, generatePath } from "react-router-dom";
import { ProtectedRoute } from "../components/ProtectedRoute";
import { RouteDefinition } from "./routes";

export const NestedRoutes: React.FC<{ routes?: RouteDefinition[] }> = ({
  routes,
}) => {
  return routes ? (
    <Switch>
      {routes.map(
        (
          {
            path,
            exact,
            component: Component,
            routes,
            modals,
            fallbackPath,
            ...config
          },
          i,
        ) => {
          const RouteComponent = config?.protected ? ProtectedRoute : Route;
          return (
            <RouteComponent
              key={i}
              path={path}
              exact={!!exact}
              render={(props) => {
                let fallbackUrl;

                if (fallbackPath) {
                  // NOTE: This will ensure segments are filled with any param matches
                  fallbackUrl = generatePath(fallbackPath, props.match.params);
                }

                return (
                  <Component
                    {...props}
                    routes={routes}
                    modals={modals}
                    fallbackUrl={fallbackUrl}
                  />
                );
              }}
            />
          );
        },
      )}
    </Switch>
  ) : null;
};
